import React from 'react';
import { Building2, Home, Building, ArrowLeft, ArrowRight } from 'lucide-react';

interface PropertyTypeStepProps {
  value: {
    propertyType: 'apartment' | 'house' | 'building' | null;
  };
  onChange: (field: string, value: any) => void;
  onNext: () => void;
  onBack?: () => void;
}

export const PropertyTypeStep: React.FC<PropertyTypeStepProps> = ({
  value,
  onChange,
  onNext,
  onBack
}) => {
  const handleTypeSelect = (type: 'apartment' | 'house' | 'building') => {
    onChange('propertyType', type);
  };

  return (
    <div className="space-y-6">
      {/* Boutons de navigation compacts en haut */}
      <div className="flex justify-between items-center pb-4 border-b border-neutral-200">
        <h2 className="text-base font-semibold text-primary">Type de bien</h2>
        <div className="flex items-center gap-2 ml-4">
          {onBack && (
            <button
              type="button"
              onClick={onBack}
              className="px-3 py-2 text-sm font-medium text-neutral-700 bg-white border border-neutral-300 rounded-lg hover:bg-neutral-50 transition-colors flex items-center gap-1"
            >
              <ArrowLeft className="h-4 w-4" />
              Précédent
            </button>
          )}
          <button
            type="button"
            onClick={onNext}
            disabled={!value.propertyType}
            className={`px-3 py-2 text-sm font-medium text-white bg-primary rounded-lg hover:bg-primary-dark transition-colors flex items-center gap-1 ${
              !value.propertyType ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            Suivant
            <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </div>
      
      <div className="grid grid-cols-3 gap-4">
        <PropertyCard
          icon={<Building2 className="h-8 w-8" />}
          type="apartment"
          label="Appartement"
          selected={value.propertyType === 'apartment'}
          onClick={() => handleTypeSelect('apartment')}
        />
        <PropertyCard
          icon={<Home className="h-8 w-8" />}
          type="house"
          label="Maison"
          selected={value.propertyType === 'house'}
          onClick={() => handleTypeSelect('house')}
        />
        <PropertyCard
          icon={<Building className="h-8 w-8" />}
          type="building"
          label="Immeuble"
          selected={value.propertyType === 'building'}
          onClick={() => handleTypeSelect('building')}
        />
      </div>
    </div>
  );
};

interface PropertyCardProps {
  icon: React.ReactNode;
  type: string;
  label: string;
  selected: boolean;
  onClick: () => void;
}

const PropertyCard: React.FC<PropertyCardProps> = ({
  icon,
  label,
  selected,
  onClick
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`
      card flex flex-col items-center p-6 transition-all
      ${selected ? 'ring-2 ring-primary bg-primary/5' : 'hover:bg-neutral-50'}
    `}
  >
    <div className={`mb-4 ${selected ? 'text-primary' : 'text-neutral-600'}`}>
      {icon}
    </div>
    <span className={`font-medium ${selected ? 'text-primary' : 'text-neutral-700'}`}>
      {label}
    </span>
  </button>
);

export default PropertyTypeStep;